/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { Else, If, Then } from "react-if";
import { ExtendedPopover, FlexContainer, SVGIcon } from "@nordcloud/gnui";
import { useNotificationsAmount } from "~/context/Notifications";
import { ROUTES } from "~/routing/routes";
import { sortByCreatedAt } from "~/tools";
import { NotificationsList } from "./NotificationList";
import { ButtonTransparent, StyledLink } from "./styles";

export function Notifications() {
  const { notificationsList, unread } = useNotificationsAmount();

  const unreadNotifications = useMemo(
    () =>
      sortByCreatedAt(notificationsList)
        .filter(({ read }) => !read)
        .slice(0, 5),
    [notificationsList]
  );

  return (
    <FlexContainer padding="0">
      <If condition={unread > 0}>
        <Then>
          <ExtendedPopover
            position="end"
            placement="bottom"
            triggerOn="click"
            closeOn="hover"
            content={
              <NotificationsList
                notifications={unreadNotifications}
                unread={unread}
              />
            }
            trigger={
              <ButtonTransparent>
                <SVGIcon name="bellActiveRed" />
              </ButtonTransparent>
            }
          />
        </Then>
        <Else>
          <StyledLink to={ROUTES.notifications.index}>
            <SVGIcon name="bell" />
          </StyledLink>
        </Else>
      </If>
    </FlexContainer>
  );
}
